<script>
import { alertComputed } from '@state/helpers';
export default {
  components: {},
  props: {
    isMouseOverNotification: {
      type: Boolean,
      required: false,
    },
    content: {
      type: String,
      required: false,
      default: '',
    },
    isAddingDish: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...alertComputed,
    isDuplicatingDay() {
      return this.content === 'day';
    },
  },
  mounted() {},
  methods: {
    cancelDuplication() {
      this.$emit('cancel-duplication');
    },
  },
};
</script>

<template>
  <div
    :class="[
      'notification-program-calendar',
      {
        isMouseOverNotification: isMouseOverNotification,
        'with-nav-banner': showAlertBanner,
      },
    ]"
  >
    <h5
      >{{ isAddingDish ? 'Add' : 'Copy' }} contents to which
      {{ isDuplicatingDay ? 'day' : 'week' }}?</h5
    >
    <p
      >Select the {{ isDuplicatingDay ? 'day' : 'week' }} you want the contents
      to appear on.</p
    >
    <a class="link blue" @click="cancelDuplication">
      Cancel <span v-if="!isAddingDish">Duplication</span>
    </a>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.notification-program-calendar {
  background-color: white;
  border-radius: $base-border-radius-md;
  box-shadow: 0 0 0.8rem rgba($color-black-wo-rgb, 0.29);
  left: 2rem;
  padding: 1.8rem 2rem;
  position: absolute;
  top: 2rem;
  width: 40.1rem;
  z-index: 3;
  &.isMouseOverNotification {
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
